import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  TextMedium,
  Card,
} from '../../components';

const StepHeader = (props) => {
  const {
    dimensions,
    configOptions,
    currentStep,
  } = props;

  return (
    <FormColumn width={dimensions.width - 45} justifyContent='center' alignItems='center'>
      <FormRow justifyContent='center'>
        <TextMedium fontSize={14} color={configOptions.textColor}>
          {currentStep === 1 && getDic("instrucoes")}
          {currentStep === 2 && getDic("reconhecimento-facial")}
          {currentStep === 3 && getDic("enviado-sucesso")}
          {currentStep === 4 && getDic("enviado-sucesso")}
        </TextMedium>
      </FormRow>
      <FormRow justifyContent='center' paddingTop={5}>
        <FormColumn paddingLeft={5} paddingRight={5}><Card width={50} opacity={currentStep > 0 ? 1 : 0.5} background={configOptions.buttonBackgroundColor} /></FormColumn>
        <FormColumn paddingLeft={5} paddingRight={5}><Card width={50} opacity={currentStep > 1 ? 1 : 0.5} background={configOptions.buttonBackgroundColor} /></FormColumn>
        <FormColumn paddingLeft={5} paddingRight={5}><Card width={50} opacity={currentStep > 2 ? 1 : 0.5} background={configOptions.buttonBackgroundColor} /></FormColumn>
      </FormRow>
    </FormColumn>
  )
};

export default StepHeader;
